import { render, staticRenderFns } from "./BoxWordStatisticsCharts.vue?vue&type=template&id=acc5bab4&"
import script from "./BoxWordStatisticsCharts.vue?vue&type=script&lang=js&"
export * from "./BoxWordStatisticsCharts.vue?vue&type=script&lang=js&"
import style0 from "./BoxWordStatisticsCharts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports